import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LineChartOutlinedSvg from "@ant-design/icons-svg/es/asn/LineChartOutlined";
import AntdIcon from "../components/AntdIcon";
var LineChartOutlined = function LineChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LineChartOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LineChartOutlined.displayName = 'LineChartOutlined';
}
export default /*#__PURE__*/React.forwardRef(LineChartOutlined);